import React, { useEffect, useState } from "react";
import { IAS_PEDAGOGY } from "../../app-constants";
import "./promo-modal.scss"; // Import your CSS file for styling

const PromoModal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show modal only once per session
    const hasSeenModal = sessionStorage.getItem("seenPromoModal");
    if (!hasSeenModal) {
      setShowModal(true);
      sessionStorage.setItem("seenPromoModal", "true");
    }
  }, []);

  const handleClose = () => setShowModal(false);

  return (
    <>
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content text-center p-1">
              {/* <button
                type="button"
                className="btn-close ms-auto"
                aria-label="Close"
                onClick={handleClose}
              ></button> */}
              {/* You can replace this section with an <img> tag for a promo image */}
              <p
                className="text-danger fw-bold"
                style={{ fontSize: "40px", margin: 0 }}
              >
                📢 Admissions Open<br/> March 2026 Batch
              </p>

              <p className="super-70-badge">
                <strong>Super 70 Program</strong> — Limited to 70 Serious
                Aspirants
              </p>

              <ul className="promo-highlights list-unstyled text-start mx-auto mt-2">
                <li>
                  🎯 <strong>Expert Faculty</strong> with a Proven & Tailored
                  UPSC Strategy
                </li>
                <li>
                  🎓 Available in <strong>Offline Classroom Mode</strong>{" "}
                  &nbsp;and &nbsp; <strong>Online Learning Mode</strong>
                </li>
                <li>
                  📚 Comprehensive <strong>Prelims & Mains Notes</strong>
                </li>
                <li>
                  📰Optional:{" "}
                  <strong>Kannada Literature and Antropology</strong>
                </li>
                <li>
                  👨‍🏫 <strong>One-on-One Mentorship</strong> for Personalized
                  Guidance
                </li>
                <li>
                  📝 Includes <strong>20 Prelims</strong> +{" "}
                  <strong>15 Mains</strong> Full-Length Tests
                </li>
                {/* <li>
                  📰 Daily <strong>Current Affairs Quiz</strong> + Monthly
                  Magazines
                </li> */}
              </ul>

              <div className="promo-price-banner my-2">
                <p style={{ marginBottom: 0 }}>
                  📞 <strong>Call/WhatsApp:</strong>{" "}
                  <br/>
                  <a href={`tel:${IAS_PEDAGOGY.OFFICE_PHONE}`}>
                    {IAS_PEDAGOGY.OFFICE_PHONE}{" "}
                  </a>{" "}
                  /{" "}
                  <a href={`tel:${IAS_PEDAGOGY.PHONE_CONTACT2}`}>
                    {IAS_PEDAGOGY.PHONE_CONTACT2}{" "}
                  </a>
                  {/* <p style={{ marginBottom: 0 }}>
                    📧 <strong>Email:</strong>{" "}
                    <a href={`mailto:${IAS_PEDAGOGY.CONTACT_EMAIL}`}>
                      {IAS_PEDAGOGY.CONTACT_EMAIL}
                    </a>
                  </p> */}
                </p>{" "}
                {/* <span className="price-tag">₹75,000</span> only! */}
              </div>

              {/* <div className="promo-contact mt-1">
                <p>
                  📞 <strong>Call/WhatsApp:</strong>{" "}
                  <a href={`tel:${IAS_PEDAGOGY.OFFICE_PHONE}`}>
                    {IAS_PEDAGOGY.OFFICE_PHONE}{" "}
                  </a>{" "}
                  |{" "}
                  <a href={`tel:${IAS_PEDAGOGY.PHONE_CONTACT2}`}>
                    {IAS_PEDAGOGY.PHONE_CONTACT2}{" "}
                  </a>
                  <p>
                    📧 <strong>Email:</strong>{" "}
                    <a href={`mailto:${IAS_PEDAGOGY.CONTACT_EMAIL}`}>
                      {IAS_PEDAGOGY.CONTACT_EMAIL}
                    </a>
                  </p>
                </p>
              </div> */}
              <button className="btn btn-primary mt-1" onClick={handleClose}>
                Got it!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PromoModal;
